import { PjmAgreementType } from '../dto/enums';
import { PjmBatteryInfo } from '../dto/PjmBatteryInfo';

type BatteryProps = {
    current: {
        batteryInfo: PjmBatteryInfo[];
    };
    update: {
        batteryKw: number;
    };
};

/**
 * During import a user can provide only total kW for batteries
 * so here we make battery with some default details (we expect zero or one battery not more)
 */
export function makeBatteryInfo({ current, update }: BatteryProps): PjmBatteryInfo[] {
    if (update.batteryKw === 0) {
        return [];
    }

    if (current.batteryInfo.length === 0) {
        /** generate new battery */
        const batteryInfo = [
            {
                maxOutput: update.batteryKw,
                capacity: undefined,
                vintage: undefined,
                chemistry: undefined,
                type: undefined,
                agreementType: PjmAgreementType.NONE,
                injectionRight: undefined,
                note: undefined,
            },
        ];

        return batteryInfo;
    }

    /** update exist battery */
    current.batteryInfo[0].maxOutput = update.batteryKw;
    return current.batteryInfo;
}
